import { SET_INTL } from '../actions/sharedIntlVariablesActions';

function sharedIntlVariablesReducer(state = {}, action) {
    const { type, intl = {} } = action;
    const { locale, localeDomain, languageAnnotations } = intl;

    switch (type) {
        case SET_INTL:
            return {
                ...state,
                locale,
                localeDomain,
                languageAnnotations,
            };
        default:
            return state;
    }
}

export default sharedIntlVariablesReducer;
